import { Trans, useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';

export const RedeemTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();

  return (
    <>
      <p data-testid="onboarding-redeem-tooltip-text">
        <Trans components={{ intro: <span />, bold: <strong />, outro: <span /> }} i18nKey="onboarding.redeemSection" />
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('buttons.gotIt')}
      </Button>
    </>
  );
};
